<script setup lang="ts">
defineProps<{
  query: URLSearchParams
  sharedData: { role?: string }
}>()
</script>

<template>
  <div class="login-redirect-loader">
    <div class="login-redirect-loader__orb">
      <v-icon size="48">mdi-check</v-icon>
    </div>
    <span v-if="sharedData.role !== undefined" class="mt-4 text-title-bold"> Регистрация завершена </span>
    <span v-else class="mt-4 text-title-bold"> Вход выполнен </span>

    <span v-if="query.get('purpose') === 'seminar'" class="mt-2 text-caption gray-text mb-6 pb-6">
      Сейчас Вы будете перенаправлены на страницу оплаты
    </span>
    <span v-else class="mt-2 text-caption gray-text mb-6 pb-6"> Сейчас Вы будете перенаправлены на сайт </span>
  </div>
</template>

<style lang="scss">
.login-redirect-loader {
  height: 100%;

  @include desktop {
    width: 320px !important;
    margin: 0 auto;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;

  &__orb {
    color: $green;
    animation: orbAnim 2s ease infinite;

    border-radius: 999px;
    padding: 8px;
  }
}

@keyframes orbAnim {
  0%,
  100% {
    background: rgba($lightGreen, 0.5);
  }
  50% {
    background: rgba($lightGreen, 0.2);
  }
}
</style>
